<script lang="ts">
    import Header from '@amp/web-app-components/src/components/Header/Header.svelte';
    import QueueItem from './QueueItem.svelte';
    import type { ItemMap } from './types';
    import { createEventDispatcher } from 'svelte';
    import { getJetPerform } from '~/jet';

    export let unplayedItems: ItemMap[] = [];
    export let panelId: string | null = null;

    const dispatch = createEventDispatcher();
    const perform = getJetPerform();

    $: ariaLabledBy = !!panelId ? `${panelId}-queue-item` : null;

    $: unplayedItemsGrouped =
        unplayedItems?.reduce((acc, item, index) => {
            const currentWork = acc.findLast((item) => item.type === 'heading');

            // Create a new heading for the first track in the queue, or for any
            // subsequeuent tracks that are not part of the same work.
            // Also populate that work header's items collection with the track
            // used to generate the new work header.
            if (
                !currentWork ||
                item.item.workOrTrackTitleGroup !== currentWork.title
            ) {
                acc.push({
                    type: 'heading',
                    title: item.item.workOrTrackTitleGroup,
                    workAction: item.item.workAction,
                    items: [item],
                });
            } else {
                // Add track item to the work heading's items array
                currentWork.items.push(item);
            }
            return acc;
        }, []) || [];

    async function handleWorkHeaderClick(segue) {
        await perform(segue);
        dispatch('close');
    }
</script>

{#each unplayedItemsGrouped as itemMap, index}
    <div class="queue-list-work" data-testid="queue-list-work">
        <Header
            title={itemMap.title}
            hasTitleLink={!!itemMap.workAction}
            isPanel={true}
            on:titleClick={() => handleWorkHeaderClick(itemMap.workAction)}
        />
        <!-- svelte-ignore a11y-no-redundant-roles -->
        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
        <ul
            role="list"
            class="queue-list"
            data-testid="queue-list"
            aria-labelledby={ariaLabledBy}
            on:keydown
        >
            {#each itemMap.items as item}
                <QueueItem
                    index={item.index}
                    item={item.item}
                    isPanel={true}
                    on:play={() => dispatch('play')}
                />
            {/each}
        </ul>
    </div>
{/each}

<style lang="scss">
    .queue-list-work {
        // queue header styles
        :global(.header-title-wrapper) {
            --header-title-chevron-size: 10px;
        }

        :global(.title) {
            --header-title-font: var(--body-emphasized);
        }

        :global(.title__button) {
            text-wrap: pretty;
        }
    }

    .queue-list-work + .queue-list-work {
        margin-top: 10px;
    }
</style>
